import { useState } from 'react'
import { StepContainer } from '../components/StepContainer'
import { useOnboardingStore } from '../store/onboardingStore'

export function WeightStep() {
  const { data, goNext } = useOnboardingStore()
  const [unit, setUnit] = useState<'kg' | 'lbs'>('lbs')
  const [value, setValue] = useState('')

  const handleContinue = () => {
    if (value) {
      const numValue = parseFloat(value)
      const weightKg = unit === 'lbs' ? Math.round(numValue * 0.453592) : numValue
      goNext({ weightKg, weightUnit: unit })
    } else {
      // Skip clears both, so the pair stays consistent after a back-and-clear.
      goNext({ weightKg: null, weightUnit: null })
    }
  }

  return (
    <StepContainer
      title="What's your weight?"
      subtitle="Optional - helps calculate protein limits"
      onContinue={handleContinue}
      continueLabel={value ? 'Continue' : 'Skip'}
    >
      <div className="flex flex-col items-center gap-6">
        {/* Unit toggle */}
        <div className="flex bg-gray-100 rounded-full p-1">
          <button
            onClick={() => setUnit('lbs')}
            className={`px-6 py-2 rounded-full text-sm font-medium transition-all ${
              unit === 'lbs' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500'
            }`}
          >
            lbs
          </button>
          <button
            onClick={() => setUnit('kg')}
            className={`px-6 py-2 rounded-full text-sm font-medium transition-all ${
              unit === 'kg' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500'
            }`}
          >
            kg
          </button>
        </div>

        {/* Weight input */}
        <div className="relative">
          <input
            type="number"
            inputMode="decimal"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={unit === 'lbs' ? '150' : '68'}
            className="w-40 text-center text-5xl font-bold text-gray-900 border-b-4 border-primary pb-2 outline-none bg-transparent placeholder:text-gray-300"
            min={unit === 'lbs' ? 66 : 30}
            max={unit === 'lbs' ? 660 : 300}
          />
          <span className="absolute right-0 bottom-4 text-xl text-gray-400 font-medium">
            {unit}
          </span>
        </div>

        <p className="text-xs text-gray-400 text-center">
          Your data is private and only used to personalize your limits
        </p>
      </div>
    </StepContainer>
  )
}
